import { Component } from '@angular/core';
import { Dessert } from 'lucide-angular';

@Component({
  selector: 'app-raw-material',
  templateUrl: './raw-material.component.html',
  styleUrls: ['./raw-material.component.scss']
})
export class RawMaterialComponent {
  resign:any[] = [
    {
      title: 'Polypropylene (PP)​​',
      img: 'assets/images/capability/orange/raw_material_1.JPG',
    },
    {
      title: 'Engineered Thermoplastics (ETP)',
      img: 'assets/images/capability/orange/raw_material_2.JPG',
      description:'ABS, ASA, Nylon, PBT, PC & PC Blends, POM',
    },
    {
      title: 'Other Engineering Plastics',
      img: 'assets/images/capability/orange/raw_material_3.JPG',
      description:'Masterbatch, PMMA, PVC,PUR, TPO, TPE,TPV',
    }
  ]

  productlist:any[] = [
    {
      title: 'Aluminium​​',
      img: 'assets/images/capability/orange/raw_material_6.JPG',
      subheading:'A356, ADC 12, ADC 1, LM6',
      description:'Ingot, Flat'
    },
    {
      title: 'Steel',
      img: 'assets/images/capability/orange/raw_material_4.JPG',
      subheading:'Primary',
      description:'Flat (CRC, HRC, Coil) , Rolled, Bar, Billet, Ingot',
      subheadingtwo:'Secondary',
      descriptiontwo:'Bar, Ingot, Billet, Die Steel',
    },
    {
      title: 'Rubber',
      img: 'assets/images/capability/orange/raw_material_9.JPG',
      subheading:'Natural & Synthetic',
      description:'Natural Rubber (NR), Epi Chloro Hydrin (ECO), EPDM, SBR| NBR | HNBR , Fluoroelastomer (FKM), Acrylic Rubber/ Ethylene Arcylate Rubber, Silicon Rubber (Si), Chloroprene Rubber (Cr)',
    }
  ]

  productlistone:any[] = [
    {
      title: 'Zinc',
      img: 'assets/images/capability/orange/raw_material_7.JPG',
      subheading:'Zamak & other Zinc Alloys',
      description:'Ingot'
    },
    {
      title: 'Copper',
      img: 'assets/images/capability/orange/raw_material_8.JPG',
      subheading:'Primary',
      description:'Copper & its alloy',
      descriptiontwo:'Sheet, Rods',
    },
    {
      title: 'Brass',
      img: 'assets/images/capability/orange/raw_material_10.JPG',
      subheading:'Brass & its alloy',
      description:'Rods, Ingot',
    }
  ]  
}
